import { render, staticRenderFns } from "./EventPns.vue?vue&type=template&id=120891f4&"
import script from "./EventPns.vue?vue&type=script&lang=js&"
export * from "./EventPns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2141801166/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('120891f4')) {
      api.createRecord('120891f4', component.options)
    } else {
      api.reload('120891f4', component.options)
    }
    module.hot.accept("./EventPns.vue?vue&type=template&id=120891f4&", function () {
      api.rerender('120891f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Events/EventPns.vue"
export default component.exports